import React from "react";
import PropTypes from "prop-types";
import { DragDropContext } from "react-beautiful-dnd";

export const withDragDropContext = Component => {
  class WithDragDropContext extends React.Component {
    state = {
      draggingRowId: null,
    };

    onDragStart = start => {
      const id = start.draggableId;
      this.props.onDragStart(start);
      this.setState({
        draggingRowId: id,
      });
    };

    onDragEnd = result => {
      const destination = result.destination;

      if (!destination || result.reason === "CANCEL") {
        this.setState({
          draggingRowId: null,
        });

        return;
      }

      this.props.onDragEnd(result);
      this.setState({
        draggingRowId: null,
      });
    };

    render() {
      const { isDraggableTable, wrapDragDropContext } = this.props;

      return isDraggableTable && wrapDragDropContext ? (
        <DragDropContext
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
        >
          <Component {...this.props} draggingRowId={this.state.draggingRowId} />
        </DragDropContext>
      ) : (
        <Component {...this.props} />
      );
    }
  }
  WithDragDropContext.propTypes = {
    onDragStart: PropTypes.func,
    onDragEnd: PropTypes.func,
    isDraggableTable: PropTypes.bool,
    wrapDragDropContext: PropTypes.bool,
  };

  WithDragDropContext.defaultProps = {
    onDragStart: () => {},
    onDragEnd: () => {},
    wrapDragDropContext: true,
  };

  return WithDragDropContext;
};
